import type { Column } from "../CompGrid";
import { TraceIdLink } from "../../links/IdLink";

export interface CreateTraceIdColumnOptions<T> {
  serviceSlug: string;
  getTraceId: (item: T) => string | null | undefined;
  /**
   * Column header label.
   * @default "Trace ID"
   */
  label?: string;
  /**
   * Max characters to show before adding "…".
   * Set to 0 to disable truncation.
   * @default 16
   */
  truncateAt?: number;
}

export function createTraceIdColumn<T>({
  serviceSlug,
  getTraceId,
  label = "Trace ID",
  truncateAt = 16,
}: CreateTraceIdColumnOptions<T>): Column<T> {
  return {
    id: "trace_id",
    label,
    sortable: true,
    sortValue: (item) => getTraceId(item) ?? "",
    render: (item) => {
      const traceId = getTraceId(item);
      return <TraceIdLink serviceSlug={serviceSlug} traceId={traceId} truncateAt={truncateAt} />;
    },
  };
}
